export const INSTAGRAM_URL = "https://www.instagram.com/gojokodo/";
